import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ReactModal from 'react-modal';
import autobind from 'autobind-decorator';

// import SongUpload from 'common/components/song-upload';
import SongUpload from 'client/shared/components/song-upload/song-upload';

import FormList from './song-form-list';

@inject('songsStore', 'formStore', 'albumsStore')
@observer
class NewSongModal extends Component {
	render () {
		const { songsStore } = this.props;

		return (
			<div>
				<ReactModal
					className="modal-container"
					isOpen={ songsStore.songModalOpen }
					contentLabel="Edit Image"
					shouldCloseOnOverlayClick={ true }
					className={{
						base: 'modal',
						afterOpen: 'modal-after-open',
						beforeClose: 'modal-before-close'
					}}
					overlayClassName={{
						base: 'modal-overlay',
						afterOpen: 'modal-overlay-after-open',
						beforeClose: 'modal-overlay-before-close'
					}}
				>
					<div className='modal-content'>
						<div className="grid-x">
							<div className="cell">
								{ this.renderMainContent() }
							</div>
						</div>

						<div className="modal-button-group">
							{ this.renderSaveBtn() }
							<button className="button clear secondary" onClick={ this.handleCloseModal }>Close Modal</button>
						</div>
					</div>
				</ReactModal>

				<button className="add-button button" onClick={ this.handleOpenModal }>
					<span className="fas fa-plus"></span> Submit Music
				</button>
			</div>
		);
	}

	renderSaveBtn () {
		const { songsStore } = this.props;
		const newSongs = songsStore.newSongs;

		if (_.isEmpty(newSongs)) {

			return null;
		}

		return <button className="button clear" onClick={ this.onClick }>Save</button>;
	}

	renderMainContent () {
		const { songsStore, formStore } = this.props;
		const newSongs = songsStore.newSongs;

		if (_.isEmpty(newSongs)) {

			return (
				<SongUpload
					songsStore={ songsStore }
					formStore={ formStore }
					fullWidth
				/>
			);
		}

		const { albumsStore } = this.props;

		return (
			<FormList songList={ newSongs } />
		);
	}

	@autobind
	onClick () {
		this.props.songsStore.saveSong();
	}

	@autobind
	handleOpenModal () {
		this.props.songsStore.songModalOpen = true;
	}

	@autobind
	handleCloseModal () {
		this.props.songsStore.songModalOpen = false;
	}
}

export default NewSongModal;
